import './style.scss';
import Chart from 'chart.js/auto';


const chartElements = document.querySelectorAll('.atcb-paid-vacation__canvas');

if (chartElements && chartElements.length !== 0) {
    chartElements.forEach(ctx => {

        const color = ctx.dataset.color;
        const number = ctx.dataset.number;

        const other = 100 - number;

        const data = {
            datasets: [{
                data: [number, other],
                backgroundColor: [color, '#EEEEEE'],
            }]
        };


        new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: {
                cutout: '64%',
                animation: false,
                plugins: {
                    tooltip: {
                        enabled: false,
                    }
                }
            }
        });
    });
}



